export class RequestconfigModel {
  //request status

  // courtagoopinionrequeststatus: boolean
  courtagoopinionrequeststatus: boolean;
  researchgrouprequeststatus: boolean;
  informationrequeststatus: boolean;
  internetdownloadrequeststatus: boolean;
  conversionrequeststatus: boolean;

  researchgrouprequestid: number;
  informationrequestid: number;
  internetdownloadrequestid: number;
  conversionrequestid: number;

  //courtagoopinionrequest Model-RequestInfo
  courtagoopinionrequestid: number;
  pickedby: number;
  date: string;
  businessunit: number;
  product: string;
  productformat: string;
  report: string;
  paragraph: string
  proceedconversion: number;
  //
  documentinfo__desiredcompletiondate: string;
  documentinfo_samedayturnaround: number;
  courtagoopinion: number;
  // ago: string;
  docketoragonumber: string;
  descisionopiniondate: string;
  courtoragoissuingstate: string;
  casenameoragosubject: string;
  judgesname: string;
  westcite: string;
  westlawcite: string;
  lexiscite: string;
  taxanalysiscite: string;
  url: string;
  othersources: string;
  documentinfo_editorscomments: string

  conversionreqdocid: string;
  conversionreqattachfile: string;

  internetdownloadproceedconversion: number;
  // researchgrouprequest Model

  //researchgrouprequestid: number;
  //details

  filename: string;
  productgroup: number;
  costcenter: number;
  detaileddescriptionofrequest: string
  attachfile: string
  shortdescriptionforyourreference: string;
  detailsdesiredcompletiondate: string;
  detailssamedayturnaround: number;
  searchtermkeywords: string;
  desirednumberofhits: string;
  costlimitations: string;
  subject: string;


  //qurey details
  querydetailsdesiredcompletiondate: string;
  querydetailssamedayturnaround: number;
  request: string;
  querydetailseditorscomments: string;

  //Download Information
  note: string;
  urlofdesireddocument: string;
  editorscomments: string;
  detaileddescriptionforuseifurlisinvalid: string;


  //CommonProperties

  documentid: number;
  documentmode: string;
  createdby: number;
  createdon: string;
  modifiedby: number;
  modifiedon: string;
  active: number;
  dbid: number;
  productdetails: ConversionrequestDetail[];
 // productfiledetails: ConversionrequestFileDetail[];
  containsgraphics: number=0;

  detailnumberofhours: number=0;
  querydetailsnumberofhours: number=0;
  documentinfonumberofhours: number=0;
  alsonotify: any;
  documenteditorscomments: string;
  documentdetaildescription: string;
  listofurlfromtemplate: any;
  templateuploadedname: string;
  supportpickedby: number;
  userdocumentid: string;
}
export class ConversionrequestDetail {
  conversionrequestdetailid: number;
  conversionrequestid: number;
  productid: number;
  productdesiredcompletiondate: string;
  desiredfilename: string;
  finaldirectory: string;
  type: number;
  outputfiles: string;
  dtdname: number;
  xmlcontentarea: string;
  productsamedayturnaround: number;
  specifyothers: string;
  createdby: number;
  createdon: string;
  modifiedby: number;
  modifiedon: string;
  active: number;
  conversioneditorscomment: string;
  numberofhours: number=0;  
  supportingfiles: string;
  productfiledetails: ConversionrequestFileDetail[];
  conversionproductname: string;



}

export
  class ConversionrequestFileDetail {
  conversionrequestfiledetailid: number; 
  conversionrequestid: number; 
  desiredfilename: string;
  outputfiles: string;
  dtdname: number;
  conversionfiles: string;  
  createdby: number;
  createdon: string;
  modifiedby: number;
  modifiedon: string;
  active: number;
  isprimary: string;
  conversionfilefrom: string;
}



